<template>
  <div class="page">
    <Header
        :title=itemTitle
    />
    <div class="container dashboard card">
      <div class="item-body">
        <pre>{{ content }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Header from './Header.vue';
import {TokenMixin} from '@/assets/js/mixins/token-mixin';
import {EventBus} from "@/eventBus";
import {ErrorsMixin} from "@/assets/js/mixins/errors-mixin";

export default {
  name: 'ItemTask',
  mixins: [
    TokenMixin,
    ErrorsMixin,
  ],
  components: {
    Header,
  },
  data() {
    return {
      id: 0,
      error: '',
      content: '...',
      itemTitle: '...',
      action: 'add',
      apiUrl: '',
      redirectToUrl: '',
      apiItem: '/api/task/',
      login: '/login',
      loading: 'loaded',
      showLoader: true,
    }
  },
  methods: {
    moveUp() {
      window.scrollTo(0, 0);
    },
    loadData() {
      let currentQuery = this.$route.query.id ? this.$route.query.id : '';
      if (currentQuery === '') {
        return;
      }
      this.id = parseInt(currentQuery);
      let loader
      if (this.showLoader) {
        loader = this.$loading.show();
      }
      this.error = '';
      axios.get(this.apiItem + currentQuery,
          this.authRespConf())
          .catch((err) => {
            if (this.showLoader) {
              loader.hide();
            }
            this.errorHandle(err, true, true);
          })
          .then(res => {
            if (this.showLoader) {
              loader.hide();
            }
            console.log('loaded data', res);
            this.content = res.data.data.Result;
            this.itemTitle = res.data.data.Name + "(" + res.data.data.StartedAt + "-" + res.data.data.StoppedAt ? res.data.data.StoppedAt : 'non stopped' + ")";
          });
    },
    handleUpdateTask(item) {
      console.log("handleUpdateTask");
      if (item === undefined || item === null) {
        console.log("handleUpdateTask item null");
        return;
      }
      console.log("handleUpdateTask item", item);
      if (item.Result !== undefined) {
        if (item.Id === this.id) {
          this.content = item.Result;
        }
        return;
      }
      if (item[this.id] !== undefined) {
        this.content = item[this.id].Result;
      }
    },
  },
  watch: {
    '$route': 'loadData'
  },
  created: function () {
    this.loadData();
    EventBus.$on("task-update", this.handleUpdateTask);
  }
}
</script>
